import { fromJS } from 'immutable';
import { visibleColumns } from './marigramReduxConstants';

export const MARIGRAM_DATA_DELETE_MARIGRAM_REQUEST = 'MARIGRAM_DATA_DELETE_MARIGRAM_REQUEST';
export const MARIGRAM_DATA_DELETE_MARIGRAM_SUCCESS = 'MARIGRAM_DATA_DELETE_MARIGRAM_SUCCESS';
export const MARIGRAM_DATA_DELETE_MARIGRAM_FAILURE = 'MARIGRAM_DATA_DELETE_MARIGRAM_FAILURE';

export const MARIGRAM_DATA_CLEAR = 'MARIGRAM_DATA_CLEAR';

export const MARIGRAM_DATA_COUNTRY_REQUEST = 'MARIGRAM_DATA_COUNTRY_REQUEST';
export const MARIGRAM_DATA_COUNTRY_SUCCESS = 'MARIGRAM_DATA_COUNTRY_SUCCESS';
export const MARIGRAM_DATA_COUNTRY_FAILURE = 'MARIGRAM_DATA_COUNTRY_FAILURE';

export const MARIGRAM_DATA_LOCATION_REQUEST = 'MARIGRAM_DATA_LOCATION_REQUEST';
export const MARIGRAM_DATA_LOCATION_SUCCESS = 'MARIGRAM_DATA_LOCATION_SUCCESS';
export const MARIGRAM_DATA_LOCATION_FAILURE = 'MARIGRAM_DATA_LOCATION_FAILURE';

export const MARIGRAM_DATA_STATE_REQUEST = 'MARIGRAM_DATA_STATE_REQUEST';
export const MARIGRAM_DATA_STATE_SUCCESS = 'MARIGRAM_DATA_STATE_SUCCESS';
export const MARIGRAM_DATA_STATE_FAILURE = 'MARIGRAM_DATA_STATE_FAILURE';

export const DELETE_MARIGRAM_DATA_REQUEST = 'DELETE_MARIGRAM_DATA_REQUEST';
export const DELETE_MARIGRAM_DATA_SUCCESS = 'DELETE_MARIGRAM_DATA_SUCCESS';
export const DELETE_MARIGRAM_DATA_FAILURE = 'DELETE_MARIGRAM_DATA_FAILURE';

export const MARIGRAM_DATA_TOGGLE_COLUMN = 'MARIGRAM_DATA_TOGGLE_COLUMN';

const initialState = fromJS({
  deleting: false,
  fetchedCountries: false,
  countries: [],
  fetchedLocations: false,
  locations: [],
  fetchedStates: false,
  states: [],
  visibleColumns,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const marigramDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case MARIGRAM_DATA_CLEAR:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
      }));

    case MARIGRAM_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case DELETE_MARIGRAM_DATA_REQUEST:
      return state.merge(fromJS({
        deleting: true,
      }));
    case DELETE_MARIGRAM_DATA_SUCCESS:
    case DELETE_MARIGRAM_DATA_FAILURE:
      return state.merge(fromJS({
        deleting: false,
      }));

    case MARIGRAM_DATA_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case MARIGRAM_DATA_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case MARIGRAM_DATA_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case MARIGRAM_DATA_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedLocations: false,
      }));
    case MARIGRAM_DATA_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedLocations: true,
        locations: action.response.items,
      }));
    case MARIGRAM_DATA_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedLocations: true,
      }));

    case MARIGRAM_DATA_STATE_REQUEST:
      return state.merge(fromJS({
        fetchedStates: false,
      }));
    case MARIGRAM_DATA_STATE_SUCCESS:
      return state.merge(fromJS({
        fetchedStates: true,
        states: action.response.items,
      }));
    case MARIGRAM_DATA_STATE_FAILURE:
      return state.merge(fromJS({
        fetchedStates: true,
      }));

    default:
      return state;
  }
};
